// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__root--GXco {
    width: 100%;
    background-color: var(--main-color);
    padding: 12px 24px;
}

    @media screen and (min-width: 1024px) {.Header__root--GXco {
        padding: 20px
}
    }

    .Header__root--GXco.Header__authenticated--_LkV {
        border-bottom: 1px solid var(--tertiary-color);
    }

.Header__subBlock--DKfL {
    width: 40px;
}

@media screen and (min-width: 1024px) {

.Header__subBlock--DKfL {
        display: none
}
    }

.Header__wrapper--qOcM {
    width: 100%;
    max-width: var(--content-max-width);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.Header__rightNav--zBRW,
.Header__leftNav--mdAx {
    display: flex;
    align-items: center;
    gap: 56px;
}

.Header__iconMenu--T8TT {
    width: 42px;
    height: 42px;
    padding: 9px;
    color: var(--tertiary-color);
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.Header__iconMenu--T8TT {
        display: none
}
    }

.Header__iconClose--Jvb3 {
    color: var(--tertiary-color);
}

.Header__iconLogin--qCQS {
    color: var(--tertiary-color);
    padding: 4px;
}

.Header__link--N3ym {
    color: var(--tertiary-color);
    font-size: 14px;
    line-height: 1;
    font-weight: 600;
    padding: 8px 0;
    border-bottom: 2px solid transparent;
    transition: 0.25s color ease-in-out, 0.25s border-color ease-in-out;
}

@media screen and (max-width: 767px) {

.Header__link--N3ym {
        display: none
}
    }

.Header__link--N3ym.Header__active--KAua {
        border-color: var(--warning-color);
    }

.Header__mobileMenuModal--vKwW {
    width: 100%;
    height: calc(100% - 66px);
    position: fixed;
    left: 0;
    top: 66px;
    background-color: var(--main-color);
}

.Header__links--imZT {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.Header__links--imZT > * {
        padding: 8px 16px;
        line-height: 32px;
        color: var(--tertiary-color);
        border: none;
    }

.Header__links--imZT > *.Header__active--KAua {
            background-color: var(--main-color);
            color: var(--tertiary-color);
        }

@media screen and (max-width: 767px) {

.Header__links--imZT > * {
            display: block
    }
        }
`, "",{"version":3,"sources":["webpack://./src/ui/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mCAAmC;IACnC,kBAAkB;AAStB;;IAPI,uCALJ;QAMQ;AAMR;IALI;;IAEA;QACI,8CAA8C;IAClD;;AAGJ;IACI,WAAW;AAKf;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,mCAAmC;IACnC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAKhC;;AAHI;;AANJ;QAOQ;AAER;IADI;;AAGJ;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,mEAAmE;AASvE;;AAPI;;AATJ;QAUQ;AAMR;IALI;;AAEA;QACI,kCAAkC;IACtC;;AAGJ;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,OAAO;IACP,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AAiBb;;AAfI;QACI,iBAAiB;QACjB,iBAAiB;QACjB,4BAA4B;QAC5B,YAAY;IAUhB;;AARI;YACI,mCAAmC;YACnC,4BAA4B;QAChC;;AAEA;;AAXJ;YAYQ;IAER;QADI","sourcesContent":[".root {\n    width: 100%;\n    background-color: var(--main-color);\n    padding: 12px 24px;\n\n    @media (--large) {\n        padding: 20px;\n    }\n\n    &.authenticated {\n        border-bottom: 1px solid var(--tertiary-color);\n    }\n}\n\n.subBlock {\n    width: 40px;\n\n    @media (--large) {\n        display: none;\n    }\n}\n\n.wrapper {\n    width: 100%;\n    max-width: var(--content-max-width);\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.rightNav,\n.leftNav {\n    display: flex;\n    align-items: center;\n    gap: 56px;\n}\n\n.iconMenu {\n    width: 42px;\n    height: 42px;\n    padding: 9px;\n    color: var(--tertiary-color);\n\n    @media (--large), (--small-tablet) {\n        display: none;\n    }\n}\n\n.iconClose {\n    color: var(--tertiary-color);\n}\n\n.iconLogin {\n    color: var(--tertiary-color);\n    padding: 4px;\n}\n\n.link {\n    color: var(--tertiary-color);\n    font-size: 14px;\n    line-height: 1;\n    font-weight: 600;\n    padding: 8px 0;\n    border-bottom: 2px solid transparent;\n    transition: 0.25s color ease-in-out, 0.25s border-color ease-in-out;\n\n    @media screen and (max-width: 767px) {\n        display: none;\n    }\n\n    &.active {\n        border-color: var(--warning-color);\n    }\n}\n\n.mobileMenuModal {\n    width: 100%;\n    height: calc(100% - 66px);\n    position: fixed;\n    left: 0;\n    top: 66px;\n    background-color: var(--main-color);\n}\n\n.links {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    > * {\n        padding: 8px 16px;\n        line-height: 32px;\n        color: var(--tertiary-color);\n        border: none;\n\n        &.active {\n            background-color: var(--main-color);\n            color: var(--tertiary-color);\n        }\n\n        @media screen and (max-width: 767px) {\n            display: block;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Header__root--GXco`,
	"authenticated": `Header__authenticated--_LkV`,
	"subBlock": `Header__subBlock--DKfL`,
	"wrapper": `Header__wrapper--qOcM`,
	"rightNav": `Header__rightNav--zBRW`,
	"leftNav": `Header__leftNav--mdAx`,
	"iconMenu": `Header__iconMenu--T8TT`,
	"iconClose": `Header__iconClose--Jvb3`,
	"iconLogin": `Header__iconLogin--qCQS`,
	"link": `Header__link--N3ym`,
	"active": `Header__active--KAua`,
	"mobileMenuModal": `Header__mobileMenuModal--vKwW`,
	"links": `Header__links--imZT`
};
export default ___CSS_LOADER_EXPORT___;
